import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { bonusApi } from '../api/rrhh'
import { fmtFecha, fmtMonto } from '../utils/fecha'
import { colors, text, radius, space, sx } from '../design/tokens'

const COLUMNAS = [
  ['Persona', 'left'], ['Acuerdo', 'left'], ['Regla', 'left'], ['Vigente desde', 'left'],
  ['Liquidaciones', 'right'], ['Total liquidado', 'right'], ['Última', 'left'], ['Estado', 'left'],
]
const td = { padding: '10px 16px' }
const tdNum = { ...td, ...sx.mono, textAlign: 'right', whiteSpace: 'nowrap' }

/** "Legajo 9999 · usuario Guga" — quién es la persona en SueAdic y en LGR. */
export function vinculoTexto(a, legajoNombre) {
  const partes = []
  if (a.legajo) partes.push(`Legajo ${a.legajo}${legajoNombre ? ` (${legajoNombre})` : ''}`)
  if (a.usuario) partes.push(`Usuario ${a.usuario.nombre}`)
  return partes.join(' · ') || 'Sin legajo ni usuario vinculado'
}

export function reglaTexto(a) {
  const p = a.parametros || {}
  if (porFacturas(a)) {
    const quien = a.procesada_por_nombre ? ` procesadas por ${a.procesada_por_nombre}` : ''
    return `${pct(p.pct)}% del valor sin impuestos de las facturas del vendedor ${p.vendedor_codigo}${quien}, cobradas por el total con recibo emitido en Presea. Las notas de crédito restan`
  }
  return `${pct(p.pct_balance)}% del balance + ${pct(p.pct_vinos)}% de los vinos s/IVA, por evento con balance positivo`
}

/** Acuerdo por facturas (comprobantes) en vez de informes de evento. */
export const porFacturas = (a) => a?.tipo === 'factura_vendedor_cobrada'

// Porcentaje tal cual está en el acuerdo (2,5% no puede leerse "3%").
const pct = (n) => {
  const num = parseFloat(n)
  return isNaN(num) ? '—' : num.toLocaleString('es-AR', { maximumFractionDigits: 2 })
}

/** Badge Vigente / Inactivo del acuerdo — mismo en el listado y en el detalle. */
export function BadgeVigencia({ activo }) {
  return (
    <span style={{ ...sx.badge, background: activo ? colors.okBg : colors.borderSoft, color: activo ? colors.ok : colors.textSec }}>
      {activo ? 'Vigente' : 'Inactivo'}
    </span>
  )
}

/**
 * RRHH → Bonus: un renglón por acuerdo de comisión/bonus con una persona.
 * Click → el acuerdo, sus liquidaciones y la liquidación nueva.
 */
export default function BonusPage() {
  const navigate = useNavigate()
  const [acuerdos, setAcuerdos] = useState([])
  const [loading, setLoading] = useState(true)

  const cargar = () => {
    setLoading(true)
    bonusApi.acuerdos().then(({ data }) => setAcuerdos(data.acuerdos)).finally(() => setLoading(false))
  }
  useEffect(cargar, [])

  return (
    <div>
      <h1 style={{ margin: `0 0 ${space.xs}px` }}>Bonus</h1>
      <p style={{ margin: `0 0 ${space.xl}px`, fontSize: text.sec, color: colors.textSec }}>
        Acuerdos de comisión o bonus con cada persona y sus liquidaciones. Cada acuerdo es particular y se escribe por código.
      </p>

      <div style={{ background: colors.bg, border: `1px solid ${colors.border}`, borderRadius: radius.lg, overflow: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: text.body }}>
          <thead>
            <tr>{COLUMNAS.map(([h, align]) => <th key={h} style={{ ...sx.th, textAlign: align }}>{h}</th>)}</tr>
          </thead>
          <tbody>
            {loading && acuerdos.length === 0 && (
              <tr><td colSpan={COLUMNAS.length} style={{ padding: 24, textAlign: 'center', color: colors.textMeta }}>Cargando…</td></tr>
            )}
            {!loading && acuerdos.length === 0 && (
              <tr><td colSpan={COLUMNAS.length} style={{ padding: 24, textAlign: 'center', color: colors.textMeta }}>
                Sin acuerdos cargados.
              </td></tr>
            )}
            {acuerdos.map(a => (
              <tr
                key={a.id}
                onClick={() => navigate(`/rrhh/bonus/${a.id}`)}
                title="Ver el acuerdo y sus liquidaciones"
                style={{ cursor: 'pointer', borderBottom: `1px solid ${colors.borderSoft}`, color: a.activo ? colors.text : colors.textMeta }}
                onMouseEnter={e => e.currentTarget.style.background = colors.bgSoft}
                onMouseLeave={e => e.currentTarget.style.background = ''}
              >
                <td style={td}>
                  <span style={{ fontWeight: 600 }}>{a.persona}</span>
                  <div style={{ fontSize: text.sec, color: colors.textMeta }}>{vinculoTexto(a)}</div>
                </td>
                <td style={td}>{a.nombre}</td>
                <td style={{ ...td, fontSize: text.sec, color: colors.textSec, maxWidth: 320 }}>{reglaTexto(a)}</td>
                <td style={{ ...td, ...sx.mono, whiteSpace: 'nowrap' }}>{a.vigente_desde ? fmtFecha(a.vigente_desde) : '—'}</td>
                <td style={tdNum}>{a.liquidaciones_vigentes}</td>
                <td style={tdNum}>{a.total_liquidado != null ? `$ ${fmtMonto(a.total_liquidado)}` : '—'}</td>
                <td style={{ ...td, ...sx.mono, whiteSpace: 'nowrap' }}>{a.ultima_liquidacion ? fmtFecha(a.ultima_liquidacion) : '—'}</td>
                <td style={td}><BadgeVigencia activo={a.activo} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

    </div>
  )
}
